import { Component, Injector, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { EditableFormComponent } from 'src/app/components/editable-form/editable-form.component';
import { InputTextComponent } from 'src/app/components/input/input-text/input-text.component';
import { EntidadeDaoService } from 'src/app/dao/entidade-dao.service';
import { IntegracaoDaoService } from 'src/app/dao/integracao-dao.service';
import { IIndexable } from 'src/app/models/base.model';
import { Integracao } from 'src/app/models/integracao.model';
import { PageFormBase } from 'src/app/modules/base/page-form-base';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-integracao-form',
  templateUrl: './integracao-form.component.html',
  styleUrls: ['./integracao-form.component.scss']
})
export class IntegracaoFormComponent extends PageFormBase<Integracao, IntegracaoDaoService> {
  @ViewChild(EditableFormComponent, { static: false }) public editableForm?: EditableFormComponent;
  @ViewChild('entidade', { static: false }) public entidade?: InputTextComponent;
  @ViewChild('usuario', { static: false }) public usuario?: InputTextComponent;

  public form: FormGroup;
  public entidadeDao: EntidadeDaoService;
  public confirmLabel: string = "Executar";
  public dataHoraExecucao: string = "";
  public production: boolean = false;
  public tipo_integracao: string = "";
  public resultado_unidades: string = '';
  public obs_unidades: string[] = [];
  public falhas_unidades: string[] = [];
  public resultado_servidores: string = '';
  public obs_servidores: string[] = [];
  public falhas_servidores: string[] = [];
  public resultado_gestores: string = '';
  public obs_gestores: string[] = [];
  public falhas_gestores: string[] = [];
  public resultado_afastamentos: string = '';
  public obs_afastamentos: string[] = [];
  public falhas_afastamentos: string[] = [];
  public resultado_participantes: string = '';
  public obs_participantes: string[] = [];
  public falhas_participantes: any = [];
  public resultado_planos_entregas: string = '';
  public obs_planos_entregas: string[] = [];
  public falhas_planos_entregas: any = [];
  public resultado_planos_trabalho: string = '';
  public obs_planos_trabalho: string[] = [];
  public falhas_planos_trabalho: any = [];
  public falhas_contribuicoes: any = [];
  public falhas_avaliacoes: any = [];
  public falhas_entregas: any = [];
  public falhas_programas_participantes: any = [];

  constructor(public injector: Injector, dao: IntegracaoDaoService) {
    super(injector, Integracao, IntegracaoDaoService);
    this.entidadeDao = injector.get<EntidadeDaoService>(EntidadeDaoService);
    this.modalWidth = 700;
    this.form = this.fh.FormBuilder({
      atualizar_unidades: { default: false },
      atualizar_servidores: { default: false },
      atualizar_gestores: { default: false },
      atualizar_afastamentos: { default: false },
      usar_arquivos_locais: { default: false },
      gravar_arquivos_locais: { default: false },
      entidade_id: { default: "" },
      usuario_id: { default: "" },
      inicio_execucao: { default: "" },
      resultado: { default: "" },
      //tipo: { default: "API_SIAPE" }
    }, this.cdRef, this.validate);
    this.join = ["entidade", "usuario"];
  }

  public loadData(entity: Integracao, form: FormGroup): void {
    this.tipo_integracao = this.url![0].path == 'integracao' ? 'API_SIAPE' : 'API_DADOS_ORGAO_CENTRAL';
    let formValue = Object.assign({}, form.value);
    form.patchValue(this.util.fillForm(formValue, entity));
    this.dataHoraExecucao = this.entity?.inicio_execucao || "";
    if (this.tipo_integracao == 'API_SIAPE') this.preparaFormularioApiSiape(entity);
    if (this.tipo_integracao == 'API_DADOS_ORGAO_CENTRAL') this.preparaFormularioApiDadosOrgaoCentral(entity);
  }

  public preparaFormularioApiSiape(entity: Integracao) {
    this.production = environment.production;
    this.form.controls.entidade_id.setValue(entity.id ? entity.entidade!.nome : this.auth.unidade?.entidade_id);
    this.form.controls.usuario_id.setValue(entity.id ? (entity.usuario_id ? entity.usuario!.nome : 'Usuário não logado') : this.auth.usuario!.id);
    this.resultado_unidades = entity.id ? JSON.parse(entity.resultado!).unidades.Resultado : '';
    this.obs_unidades = entity.id ? JSON.parse(entity.resultado!).unidades.Observações : [];
    this.falhas_unidades = entity.id ? JSON.parse(entity.resultado!).unidades.Falhas : [];
    this.resultado_servidores = entity.id ? JSON.parse(entity.resultado!).servidores.Resultado : '';
    this.obs_servidores = entity.id ? JSON.parse(entity.resultado!).servidores.Observações : [];
    this.falhas_servidores = entity.id ? JSON.parse(entity.resultado!).servidores.Falhas : [];
    this.resultado_gestores = entity.id ? JSON.parse(entity.resultado!).gestores.Resultado : '';
    this.obs_gestores = entity.id ? JSON.parse(entity.resultado!).gestores.Observações : [];
    this.falhas_gestores = entity.id ? JSON.parse(entity.resultado!).gestores.Falhas : [];
    this.resultado_afastamentos = entity.id ? JSON.parse(entity.resultado!).afastamentos.Resultado : '';
    this.obs_afastamentos = entity.id ? JSON.parse(entity.resultado!).afastamentos.Observações : [];
    this.falhas_afastamentos = entity.id ? JSON.parse(entity.resultado!).afastamentos.Falhas : [];
  }

  public preparaFormularioApiDadosOrgaoCentral(entity: Integracao) {
    this.resultado_participantes = entity.id ? JSON.parse(entity.resultado!).participantes.Resultado : '';
    this.obs_participantes = entity.id ? JSON.parse(entity.resultado!).participantes.Observações : [];
    this.falhas_participantes = entity.id ? JSON.parse(entity.resultado!).falhas.participantes : [];
    this.resultado_planos_entregas = entity.id ? JSON.parse(entity.resultado!).planosEntrega.Resultado : '';
    this.obs_planos_entregas = entity.id ? JSON.parse(entity.resultado!).planosEntrega.Observações : [];
    this.falhas_planos_entregas = entity.id ? JSON.parse(entity.resultado!).falhas.planosEntrega : [];
    this.resultado_planos_trabalho = entity.id ? JSON.parse(entity.resultado!).planosTrabalho.Resultado : '';
    this.obs_planos_trabalho = entity.id ? JSON.parse(entity.resultado!).planosTrabalho.Observações : [];
    this.falhas_planos_trabalho = entity.id ? JSON.parse(entity.resultado!).falhas.planosTrabalho : [];
    this.falhas_contribuicoes = entity.id ? JSON.parse(entity.resultado!).falhas.contribuicoes : [];
    this.falhas_avaliacoes = entity.id ? JSON.parse(entity.resultado!).falhas.avaliacoes : [];
    this.falhas_entregas = entity.id ? JSON.parse(entity.resultado!).falhas.entregas : [];
    this.falhas_programas_participantes = entity.id ? JSON.parse(entity.resultado!).falhas.programas_participantes : [];
  }

  public initializeData(form: FormGroup): void {
    this.loadData(new Integracao(), form);
  }

  public saveData(form: IIndexable): Promise<Integracao> {
    return new Promise<Integracao>((resolve, reject) => {
      let integracao = this.util.fill(new Integracao(), this.entity!);
      integracao = this.util.fillForm(integracao, this.form!.value);
      integracao.tipo = this.tipo_integracao;
      integracao.usuario_id = this.auth.usuario?.id;
      integracao.entidade_id = this.auth.entidade?.id;
      this.dataHoraExecucao = this.util.getDateTimeFormatted(new Date());
      integracao.inicio_execucao = this.dataHoraExecucao;
      resolve(integracao);
    });
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
    if (['atualizar_gestores'].includes(controlName) && this.form?.controls.atualizar_gestores?.value && (!this.form?.controls.atualizar_unidades?.value || !this.form?.controls.atualizar_servidores?.value)) result = "É necessário atualizar unidades e servidores para atualizar os gestores.";
    return result;
  }

  public getFormattedDataExecucao(): string {
    const entity = this.entity;
    return this.util.getDateTimeFormatted(entity ? this.entity?.inicio_execucao : new Date());
  }

  public duracao() {
    const diff = Math.abs(this.util.stringToDate(this.dataHoraExecucao).getTime() - Date.now());
    const h = Math.floor(diff / (1000 * 60 * 60));
    const m = Math.floor((diff / 1000 - h * 3600) / 60);
    const s = Math.floor((diff / 1000 - h * 3600) % 60);

    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
}
